import classnames from 'classnames';
import isEmpty from 'lodash/isEmpty';
import React from 'react';
import PropTypes from 'prop-types';
import Form from 'antd/es/form';

import HTML from 'molecules/HTML';
import Icon from 'molecules/Icon';

import './Form.scss';

/* ------ = Functionality. = --------------------------------------------------------------------- */


/* ------ = Components. = --------------------------------------------------------------------- */

let propTypes = {};
let defaultProps = {};

/**
 * Group Heading.
 */
Form.Heading = ( { children, ...p } ) => (

  <h4
  className="Form__hding"
  { ...p }
  >
    { children }
  </h4>

);

/**
 * Submitted.
 */
propTypes = {
  type: PropTypes.string,
  message: PropTypes.string,
}
Form.Submitted = p => (

  <div className={ classnames( 'Form__submitted', `is-${p.type}` ) }>

    { p.type === 'success'

      ? <Icon type="check-circle" theme="filled"/>

      : <Icon type="warning" />

    }

    { p.message

      ?
        <p>
          <HTML>{ p.message }</HTML>
        </p>
      :
        p.children

    }


  </div>

);
Form.Submitted.propTypes = propTypes;

/**
 * Default export of antdform.
 */
export default Form;

/**
 * Wrapped form.
 *
 * @param {Component} form
 */
propTypes = {
  type: PropTypes.string,
  inputShade: PropTypes.string,
  withLabels: PropTypes.bool,
}
defaultProps = {
  inputShade: 'light',
  type: 'standard',
}
export const WrappedForm = React.memo( p => {

  const { form, onFieldsChange, onValuesChange, ...formProps } = p;
  const Wrapped = React.memo( Form.create( {
    onValuesChange,
    onFieldsChange
  } )( form ) );

  return (

    <div className={ classnames( 'Form', `with-${p.inputShade}-inputs`, {
      [`is-${p.type}`]: !! p.type,
      ['with-labels']: p.withLabels,
    } ) }
    >
      <Wrapped { ...formProps } />
    </div>

  );

}, ( prevProps, newProps ) => {

  // Only compare non form props.
  const { form: prevForm, ...prevStuff } = prevProps;
  const { form: newForm, ...newStuff } = newProps;

  if(
    JSON.stringify( prevStuff ) === JSON.stringify( newStuff ) ||
    isEmpty( prevStuff ) && isEmpty( newStuff )
  ) {
    return true;
  }
  else {
    return false;
  }


} );
WrappedForm.propTypes = propTypes;
WrappedForm.defaultProps = defaultProps;

/**
 * Wrap form with Ant's functionality.
 *
 * @param {Component} component
 * @return form component wrapped with extra functionality.
 */
export const withFormWrap = component => {

  const WrappedForm = Form.create()( component );

  return props => (

    <div className="Form">

      <WrappedForm
      {...props}
      />

    </div>

  )


}
